import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Grid, Button, Divider } from "semantic-ui-react";
import { Formik, Form } from "formik";

import * as Yup from "yup";
import * as Schemas from "../../forms/validationSchemas.js";

import AcceptButton from "./AcceptButton.jsx";

import { OPERATIONS } from "../../../constants/operations.js";

import { operationAvailability } from "../../../utils/operations.js";

// Designed to be used with the withBasicForm HOC

class InviteResponseForm extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    onFormikSubmit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
    violationErrors: PropTypes.object,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "invite.pending"
  };

  constructor(props) {
    super(props);

    this.initialValues = {
      challengeResponse: ""
    };
  }

  // -- VALIDATION -- //

  validationSchema = () => {
    const messages = this.props.copy("forms.validation_requirements");

    return Yup.object().shape({
      challengeResponse: Schemas.requiredString("Password", messages, true)
    });
  };

  // -- RENDER -- //

  // seperating only to make renderOperations clearer
  renderDivider = visible => {
    const { copyKey } = this.props;

    if (!visible) return null;

    return (
      <Divider horizontal>
        {this.props.copy(`${copyKey}.action_divider`)}
      </Divider>
    );
  };

  renderOperations = () => {
    const {
      data,
      onSubmit,
      onReject,
      onDelete,
      violationErrors,
      copyKey,
      copy
    } = this.props;

    const accept = operationAvailability(
      OPERATIONS.ACCEPT,
      data.operations
    ).available;
    const reject = operationAvailability(
      OPERATIONS.REJECT,
      data.operations
    ).available;
    const del = operationAvailability(
      OPERATIONS.DELETE,
      data.operations
    ).available;

    if (accept || reject || del) {
      const acceptCTACopyKey = data.challengeRequired
        ? `${copyKey}.accept_cta`
        : `${copyKey}.accept_no_challenge_cta`;

      return (
        <Grid.Column textAlign="center">
          {accept && (
            <Form>
              {data.challengeRequired && (
                <p>{copy(`${copyKey}.accept_description`)}</p>
              )}
              <AcceptButton
                ctaCopy={copy(acceptCTACopyKey)}
                placeholderCopy={copy(`${copyKey}.password_input_placeholder`)}
                challengeRequired={data.challengeRequired}
                violationErrors={violationErrors}
              />
            </Form>
          )}

          {this.renderDivider(accept && reject)}

          {reject && (
            <Button
              color="red"
              onClick={onReject}
              content={copy(`${copyKey}.reject_cta`)}
            />
          )}

          {this.renderDivider((accept && del) || (reject && del))}

          {del && (
            <Button
              onClick={onDelete}
              icon="trash alternate"
              content="Delete Invite"
            />
          )}
        </Grid.Column>
      );
    }

    return null;
  };

  onFormikSubmit = values => {
    this.props.onSubmit(values);
  };

  render() {
    const { data, onFormikSubmit } = this.props;

    let validationOptions = {
      initialValues: this.initialValues // required by semantic-ui react
    };

    if (data.challengeRequired === true) {
      validationOptions = {
        initialValues: this.initialValues, // required by semantic-ui react
        validateOnMount: true,
        validationSchema: this.validationSchema()
      };
    }

    return (
      <Formik {...validationOptions} onSubmit={onFormikSubmit}>
        {formikProps => {
          return this.renderOperations(formikProps);
        }}
      </Formik>
    );
  }
}

export default InviteResponseForm;
